module.exports = __webpack_public_path__ + "static/img/Photo.c61a213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Photo.png
// module id = l3gC
// module chunks = 1